import { flatRowTypes } from '../constants';
import isGroupedItems from './is-grouped-items';

function getFlatRows(items, expandedIds, depth = 0) {
  const result = [];

  if (isGroupedItems(items)) {
    items.forEach((group) => {
      result.push({ type: flatRowTypes.GROUP_LABEL, id: group.id, label: group.label, depth });
      result.push(...getFlatRows(group.items, expandedIds, depth));
    });

    return result;
  }

  items.forEach((item) => {
    const hasChildren = Boolean(item.items?.length);
    const isExpanded = hasChildren && expandedIds.has(item.id);

    result.push({
      type: flatRowTypes.ITEM,
      id: item.id,
      item,
      depth,
    });

    if (isExpanded && item.items) {
      result.push(...getFlatRows(item.items, expandedIds, depth + 1));
    }
  });

  return result;
}

export default getFlatRows;
